<template>
  <div class="kt-portlet kt-portlet--mobile">
    <div class="kt-form" ref="form">
      <!--begin::Form-->
      <form class="kt-form" @submit.prevent="formSubmit($event)">
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="kt-font-brand flaticon-home"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <div class="kt-section kt-section--first">
            <div class="row mb-3">
              <div class="col-xl-6">
                <input
                  type="file"
                  class="custom-file-input"
                  id="importFilePhase"
                  lang="es"
                />
                <label class="custom-file-label" for="importFilePhase">{{
                  Flie
                }}</label>
                <!-- <button id="import" class="btn btn-primary" @click="ImportFile">อัพโหลด</button> -->
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12 table-responsive">
                <table
                  class="table-sm table-striped- table-bordered table-hover table-checkable"
                  id="PreviewTable"
                  style="width: 100%;"
                ></table>
              </div>
            </div>
          </div>
        </div>
        <div class="kt-portlet__foot">
          <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            @click="$router.go(-1)"
          >
            <i class="la la-close"></i> ย้อนกลับ
          </button>
          <button type="reset" class="btn btn-danger" @click="resetFile">
            <i class="la la-close"></i> ล้างค่า
          </button>
          <button type="submit" class="btn btn-primary">
            <i class="la la-save"></i> บันทึกข้อมูล
          </button>
        </div>
      </form>
      <!--end::Form-->
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data: function() {
    var self = this;
    return {
      Flie: "เลือกไฟล์",
      seen: false,
      phaseList: [],
    };
  },
  methods: {
    resetFile: function() {
      $("#PreviewTable thead").remove();
      $("#PreviewTable tbody").remove();
      $("#importFilePhase").val("");
      this.seen = false;
      this.Flie = "เลือกไฟล์";
      this.phaseList = [];
    },
    formSubmit: function(e) {
      e.preventDefault();
      var valid = false;
      // this.phaseList.forEach(element => {
      //   valid = valid || element.validates;
      // });
      // if (valid) {
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่...",
      });

      let self = this;
      let router = this.$router;
      axios
        .post("/Api/MasterPhase/Import", this.phaseList)
        .then(function(response) {
          if (response.data.status) {
            Swal.fire("สำเร็จ", response.data.message, "success").then(
              function() {
                router.go(-1), self.$parent.reloadDataTable(false);
              }
            );
          } else {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
        });
      // }
    },
  },
  async mounted() {
    let self = this;
    let router = this.$router;
    let user = await this.$root.getUser();

    $("#importFilePhase").change(function(e) {
      self.seen = true;
      self.Flie = e.target.files[0].name;

      $("#PreviewTable thead").remove();
      $("#PreviewTable tbody").remove();

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังแสดงข้อมูล กรุณารอสักครู่...",
      });

      let formData = new FormData();
      formData.append("file", e.target.files[0]);
      axios
        .post("/Api/MasterPhase/Preview", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          self.phaseList = response.data;
          var $table = $("#PreviewTable");
          var head =
            "<thead>" +
            '<tr role="row">' +
            '<th class="text-center" aria-label="ลำดับ: activate to sort column ascending" >ลำดับ</th>' +
            '<th class="text-center" aria-label="Phase: activate to sort column ascending" >Phase</th>' +
            '<th class="text-center" aria-label="Lot: activate to sort column ascending" style="width:8% ;" >Lot</th>' +
            '<th class="text-center" aria-label="Material Code: activate to sort column ascending">รหัสสินค้า</th>' +
            '<th class="text-center" aria-label="ID: activate to sort column ascending">ID</th>' +
            "</tr>" +
            "</thead>";
          $table.append(head);
          var data = response.data;
          var table_body = $("<tbody></tbody>");
          for (var i = 0; i < data.length; i++) {
            var borders_materialcode = null;
            if (!data[i].validates) {
              borders_materialcode = 'style="color:#ff0000;"';
            }
            $(
              '<tr role="row" class="odd"><td class="text-center">' +
                (i + 1) +
                "</td>" +
                '<td class="text-center">' +
                data[i].phase +
                "</td>" +
                '<td class="text-center">' +
                data[i].lot +
                "</td>" +
                '<td class="text-center" ' +
                borders_materialcode +
                ">" +
                data[i].hMaterial +
                "</td>" +
                '<td class="text-center" ' +
                borders_materialcode +
                ">" +
                data[i].pId +
                "</td>" +
                "</tr>"
            ).appendTo(table_body);
            table_body.appendTo($table);
          }
          KTApp.unblockPage();
        });
    });

    // set validation rules
    // $("#importBarcodeModal form").validate({
    //   rules: {},
    //   messages: {}
    // });

    // $("#importBarcodeModal")
    //   .on("hidden.bs.modal", function() {
    //     // Set go back
    //     router.go(-1);
    //     self.$parent.reloadDataTable(false);
    //   })
    //   .modal("show");
  },
};
</script>

<style lang="scss" scoped>
input[type="file"] {
  cursor: pointer;
}
td.border_single {
  border: 1px solid #ff0000;
}
</style>



// WEBPACK FOOTER //
// App/Components/Master/Phase/ImportPhase.vue